import { shallowEqual, useSelector } from 'react-redux';
import { getClassicGameUserChances } from '../selectors';

export const useUserTrade = () => ({
  trade: useSelector(getClassicGameUserChances, shallowEqual),
});
